import { useState } from "react";

import { Grid, InputAdornment } from "@mui/material";

import { editObjectData } from "@aclymatepackages/array-immutability-helpers";
import { TextField } from "@aclymatepackages/atoms";
import { numbersRegExpTest } from "@aclymatepackages/reg-exp";

import SpendBasedVendorInputs from "../vendors/SpendBasedVendorInputs";

const SpendBasedInputBlock = ({
  value,
  setValue,
  isValueDisabled,
  areNaicsInputsDisabled,
  editVendor,
  vendorCategoryData,
  knownVendorNaicsTitle,
  disabled,
}) => {
  return (
    <Grid item container spacing={2} direction="column">
      <Grid item>
        <TextField
          value={value}
          setValue={setValue}
          label="Dollar Value"
          InputProps={{ startAdornment: <InputAdornment>$</InputAdornment> }}
          disabled={isValueDisabled || disabled}
        />
      </Grid>
      <SpendBasedVendorInputs
        editVendor={editVendor}
        disabled={areNaicsInputsDisabled || disabled}
        questionText="What did you buy and where did you buy it?"
        overrideNaicsTitle={knownVendorNaicsTitle}
        {...vendorCategoryData}
      />
    </Grid>
  );
};

const useSpendBasedInput = ({ transaction = {}, onSave }) => {
  const {
    amount: existingAmount = 0,
    dollarAmount: existingDollarAmount = 0,
    vendorId,
    source,
    emissionData,
    status,
  } = transaction;
  const {
    naicsCode: transactionNaicsCode,
    naicsTitle: transactionNaicsTitle,
    scopeThreeCategory: transactionScopeThreeCategory,
    tonsCo2ePerDollar: transactionTonsCo2ePerDollar,
  } = emissionData || {};

  const [amount, setAmount] = useState(existingDollarAmount || existingAmount);
  const [vendorCategoryData, setVendorCategoryData] = useState(
    {
      scopeThreeCategory: transactionScopeThreeCategory,
      naicsCode: transactionNaicsCode,
      naicsTitle: transactionNaicsTitle,
      tonsCo2ePerDollar: transactionTonsCo2ePerDollar,
    } || {}
  );

  const editVendorCategoryData = (field) => (value) =>
    editObjectData(setVendorCategoryData, field, value);

  const {
    naicsTitle = transactionNaicsTitle,
    naicsCode = transactionNaicsCode,
    tonsCo2ePerDollar = transactionTonsCo2ePerDollar,
    scopeThreeCategory = transactionScopeThreeCategory,
  } = vendorCategoryData || {};

  const tonsCo2e = Math.abs(amount * tonsCo2ePerDollar);

  const onTransactionSave = () =>
    onSave({
      tonsCo2e,
      amount,
      emissionData: {
        naicsCode,
        naicsTitle,
        tonsCo2ePerDollar,
        scopeThreeCategory,
      },
    });
  const saveEnabled = naicsCode && amount && numbersRegExpTest(amount);

  const isValueDisabled = source !== "manual-entry" && !!vendorId;

  const inputBlock = (
    <SpendBasedInputBlock
      value={amount}
      setValue={setAmount}
      isValueDisabled={isValueDisabled}
      areNaicsInputsDisabled={!!vendorId && scopeThreeCategory && naicsCode}
      editVendor={editVendorCategoryData}
      vendorCategoryData={{
        naicsTitle,
        naicsCode,
        tonsCo2ePerDollar,
        scopeThreeCategory,
      }}
      originalNaicsTitle={transactionNaicsTitle}
      disabled={status === "locked"}
    />
  );

  return {
    inputBlock,
    onTransactionSave,
    saveEnabled,
    tonsCo2e,
  };
};
export default useSpendBasedInput;
